// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"VaultStatsTiles_swiperContainer__1tPgr","swiperSlide":"VaultStatsTiles_swiperSlide__aupOA","button":"VaultStatsTiles_button__1UXhV"};